import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import { useLazyGetVendorTransactionReportDetailQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportVendorTransactionDetail = ({ vendorId }) => {
  const [fetchVendorTransactionDetail, { isLoading, isFetching }] =
    useLazyGetVendorTransactionReportDetailQuery();

  const handleDownload = async (data) => {
    try {
      const responseData = await fetchVendorTransactionDetail({
        vendorProfile: vendorId,
      }).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        Vendor:
          row.vendorProfile?.ownerName || row.vendorProfile?.shopName || "N/A",
        "Shipment Id": row.shipmentId || "N/A",
        Charge: row.charge || "N/A",
        Status: row.paymentStatus || "N/A",
        Date: row.createdAt
          ? moment(row.createdAt).format("YYYY-MM-DD")
          : "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "Vendor_Transaction_Report_Detail",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error(
        "Error fetching vendor transaction report data: " + error.message
      );
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportVendorTransactionDetail;
